/* Publish by EComposer at 2025-07-29 16:32:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1mrkdbwy3u1"]=  window.__ectimmers["ecom-1mrkdbwy3u1"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-1mrkdbwy3u1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1mrkdbwy3u1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jt41w83q6g7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jt41w83q6g7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mnibzhg8ee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mnibzhg8ee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-glbd87500t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-glbd87500t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2txojehd98y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2txojehd98y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gsfojrsjsuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gsfojrsjsuo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dh6mgoly55g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dh6mgoly55g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mzxasnbjda').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mzxasnbjda', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yapca19c21').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yapca19c21', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c3xwejfncq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c3xwejfncq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihifc4ndhce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihifc4ndhce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qkqkebvbond').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qkqkebvbond', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yq7hwm2k7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yq7hwm2k7n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-md2h2xux7z7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-md2h2xux7z7', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3vuy93p7vpb"]=  window.__ectimmers["ecom-3vuy93p7vpb"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-3vuy93p7vpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3vuy93p7vpb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddvfflz97o4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddvfflz97o4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qkihkxrxcbd"]=  window.__ectimmers["ecom-qkihkxrxcbd"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),r=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),l=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){r==="text"&&s?(s.style.display="inherit",l.style.display="none"):l.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-qkihkxrxcbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qkihkxrxcbd', settings: {"content_type":"text"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}